import React from 'react';

import {
  Breadcrumbs as BreadcrumbsCore,
} from '@uncinc/react-drupal-core';

import './style.scss';

const Breadcrumbs = () => (
  <BreadcrumbsCore
    includeCurrent
    hideHome
  />
);

export default Breadcrumbs;
